const header = {
  organisationLocation: 'Organisation - Location',
  organisation: 'Organisation',
  location: 'Location',
  quickAction: 'Quick Action',
  addAppointment: 'Add Appointment',
  addPatient: 'Add Patient',
  addTask: 'Add Task',
  startCall: 'Start Call',
  notification: 'Notifications',
  checkAllNotifications: 'Check all notifications',
  myProfile: 'My Profile',
  settings: 'Settings',
  logout: 'Logout'
}


export default header
